const techServices = [
  {
    icon: 'ri-cloud-line',
    title: 'Cloud & SaaS Consultancy',
    desc: 'Strategic guidance for cloud migration, SaaS implementation, and hybrid infrastructure optimization across manufacturing, finance, and research sectors',
    tech: 'AWS · Azure · Google Cloud · Salesforce',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Advanced Data Analytics',
    desc: 'Big data processing, predictive analytics, and business intelligence solutions for automotive, healthcare, and financial services organizations',
    tech: 'Tableau · Snowflake · Apache Spark · Databricks',
  },
  {
    icon: 'ri-robot-2-line',
    title: 'Robotics & Automation',
    desc: 'Process automation, RPA, and intelligent workflow optimization for manufacturing and automotive industries at scale',
    tech: 'UiPath · Blue Prism · Automation Anywhere',
  },
  {
    icon: 'ri-settings-4-line',
    title: 'SAP & ERP Solutions',
    desc: 'Enterprise resource planning implementation, SAP consulting, and business process optimization for large-scale operations',
    tech: 'SAP S/4HANA · Oracle ERP · Microsoft Dynamics',
  },
  {
    icon: 'ri-brain-line',
    title: 'Machine Learning & AI',
    desc: 'Custom AI model development, machine learning implementation, and intelligent system integration for research and healthcare sectors',
    tech: 'TensorFlow · PyTorch · Azure ML · SageMaker',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Digital Security & Compliance',
    desc: 'Cybersecurity frameworks, regulatory compliance, and data governance solutions ensuring secure digital transformation',
    tech: 'ISO 27001 · GDPR · SOX · HIPAA',
  },
];

export default function DigitalTransformationSection() {
  return (
    <section className="py-24 relative" style={{ background: 'linear-gradient(180deg, #09090f 0%, #0e0e1a 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase mb-4" style={{ color: '#c9a84c' }}>
            Enterprise AI
          </span>
          <h2 className="text-4xl font-light text-white mb-6 tracking-tight">
            Digital Transformation{' '}
            <span style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: 600 }}>
              Technology Services
            </span>
          </h2>
          <p className="text-lg text-white/45 max-w-3xl mx-auto font-light">
            Comprehensive technology consultancy empowering Manufacturing, Finance, Research, Automotive, Healthcare, and Retail through intelligent digital transformation solutions
          </p>
        </div>

        {/* Banner */}
        <div className="mb-20 overflow-hidden relative" style={{ borderRadius: '16px', border: '1px solid rgba(201,168,76,0.2)' }}>
          <img
            alt="Éclat-Gen Digital Transformation Hub"
            className="w-full h-80 object-cover object-center"
            src="https://public.readdy.ai/ai/img_res/342e8461b8130d7da1d55851dcd42d2f.jpg"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(9,9,15,0.7) 0%, rgba(9,9,15,0.2) 50%, rgba(9,9,15,0.5) 100%)' }} />

          {/* Badges */}
          {[
            { pos: 'top-5 left-5', icon: 'ri-brain-line', label: 'Machine Learning', sub: 'AI Model Dev' },
            { pos: 'top-5 right-5', icon: 'ri-cpu-line', label: 'Deep Learning', sub: 'Neural Networks' },
            { pos: 'bottom-5 left-5', icon: 'ri-bar-chart-line', label: 'Data Analytics', sub: 'Predictive Modeling' },
            { pos: 'bottom-5 right-5', icon: 'ri-robot-line', label: 'AI Automation', sub: 'Intelligent Systems' },
          ].map((badge) => (
            <div
              key={badge.label}
              className={`absolute ${badge.pos} flex items-center gap-3 px-4 py-3`}
              style={{ background: 'rgba(9,9,15,0.88)', backdropFilter: 'blur(16px)', borderRadius: '8px', border: '1px solid rgba(201,168,76,0.25)' }}
            >
              <div className="w-8 h-8 flex items-center justify-center" style={{ background: 'rgba(201,168,76,0.15)', borderRadius: '6px' }}>
                <i className={`${badge.icon} text-sm`} style={{ color: '#c9a84c' }} />
              </div>
              <div>
                <div className="text-xs font-semibold text-white/85 tracking-wide">{badge.label}</div>
                <div className="text-xs" style={{ color: '#c9a84c' }}>{badge.sub}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Service Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {techServices.map((svc) => (
            <div
              key={svc.title}
              className="p-7 transition-all duration-300 group cursor-pointer"
              style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(201,168,76,0.12)', borderRadius: '12px' }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLDivElement).style.background = 'rgba(201,168,76,0.05)';
                (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(201,168,76,0.3)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLDivElement).style.background = 'rgba(255,255,255,0.02)';
                (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(201,168,76,0.12)';
              }}
            >
              <div className="w-12 h-12 flex items-center justify-center mb-5" style={{ background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '10px' }}>
                <i className={`${svc.icon} text-xl`} style={{ color: '#c9a84c' }} />
              </div>
              <h3 className="text-base font-semibold text-white/90 mb-3 tracking-wide">{svc.title}</h3>
              <p className="text-sm text-white/40 mb-4 font-light leading-relaxed">{svc.desc}</p>
              <div className="text-xs font-medium tracking-wide" style={{ color: 'rgba(201,168,76,0.55)' }}>{svc.tech}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
